import { render } from "./model.vue?vue&type=template&id=28ddc0d0&scoped=true"
import script from "./model.vue?vue&type=script&lang=js"
export * from "./model.vue?vue&type=script&lang=js"

import "./model.vue?vue&type=style&index=0&id=28ddc0d0&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Codes/d86e-client-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ddc0d0"]])

export default __exports__